<header class="border border-b-[var(--light-beige)]" style="background-color: var(--beige); overflow-x: hidden;" [ngStyle]="{'background-image': isHome ? 'url(assets/fondo-rugoso.webp)' : ''}">
  <div class="mx-auto max-w-screen-desktop container-padding">
    <nav class="py-6 relative z-[1000]">
      <div class="flex justify-between items-center w-full">
        
        <!-- Hamburger (Mobile Only) -->
        <div class="tablet:hidden flex items-center order-1 w-[auto]">
          <button
            type="button"
            class="btn-burger w-full"
            (click)="toggleMobileMenu()"
            >
            <svg width="27" height="22" viewBox="0 0 27 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M24.3 17.6H2.7C1.2096 17.6 0 18.5856 0 19.8C0 21.0144 1.2096 22 2.7 22H24.3C25.7904 22 27 21.0144 27 19.8C27 18.5856 25.7904 17.6 24.3 17.6ZM24.3 8.8H2.7C1.2096 8.8 0 9.7856 0 11C0 12.2144 1.2096 13.2 2.7 13.2H24.3C25.7904 13.2 27 12.2144 27 11C27 9.7856 25.7904 8.8 24.3 8.8ZM2.7 4.4H24.3C25.7904 4.4 27 3.4144 27 2.2C27 0.9856 25.7904 0 24.3 0H2.7C1.2096 0 0 0.9856 0 2.2C0 3.4144 1.2096 4.4 2.7 4.4Z" fill="white"/>
            </svg>
          </button>
        </div>

        <!-- Logo (Center Mobile, Left Desktop) -->
        <div class="text-xl font-semibold order-2 tablet:order-1 flex-1 text-center tablet:flex-none tablet:text-left">
          <a routerLink="home" class="inline-flex items-center">
            <img src="assets/logo.webp" alt="Drinkhopping logo" class="h-[69px] object-cover w-auto">
          </a>
        </div>

        <!-- Cart Icon (Mobile Only) -->
        <div class="tablet:hidden flex items-center justify-end order-3 w-[40px]">
          <a #cartIcon routerLink="/cart" routerLinkActive="cart-active" [routerLinkActiveOptions]="{exact: true}" class="relative transition-colors duration-200 hover:text-[var(--dark-orange)]" aria-label="Carrito de compras">
            <fa-icon [icon]="faShoppingCart" size="2xl"></fa-icon>
            <span *ngIf="((cartItemCount$ | async) || 0) > 0" class="absolute -top-2 -right-2 bg-red-600 text-white text-xs font-bold rounded-full h-4 w-4 flex items-center justify-center">
              {{ cartItemCount$ | async }}
            </span>
          </a>
        </div>

        <!-- Desktop Menu -->
        <div class="hidden tablet:flex items-center gap-6 desktop:gap-12 order-4 tablet:order-2">
          <a routerLinkActive="routerActive" routerLink="" [routerLinkActiveOptions]="{exact: true}" class="uppercase font-normal transition-colors duration-200 hover:text-[var(--dark-orange)]" style="font-size: 15px">{{ 'nav.home' | translate }}</a>
          <a routerLinkActive="routerActive" routerLink="/events" class="uppercase font-normal transition-colors duration-200 hover:text-[var(--dark-orange)]" style="font-size: 15px">{{ 'nav.events' | translate }}</a>
          <a routerLinkActive="routerActive" routerLink="/register" class="uppercase font-normal transition-colors duration-200 hover:text-[var(--dark-orange)]" style="font-size: 15px" [ngClass]="{'hidden': (isAuthenticated$ | async)}">{{ 'nav.register' | translate }}</a>
          <a routerLinkActive="routerActive" routerLink="/new-hop" class="uppercase font-normal w-min desktop:w-auto transition-colors duration-200 hover:text-[var(--dark-orange)]" style="font-size: 15px">{{ 'nav.newHop' | translate }}</a>

          <a routerLinkActive="routerActive" [ngClass]="{'hidden': !(isAuthenticated$ | async)}" routerLink="/profile" class="uppercase font-normal text-center transition-colors duration-200 hover:text-[var(--dark-orange)]" style="font-size: 15px">{{ 'nav.profile' | translate }}</a>
          <a routerLinkActive="routerActive" [ngClass]="{'hidden': !(isAuthenticated$ | async)}" routerLink="/reservations" class="uppercase font-normal transition-colors duration-200 hover:text-[var(--dark-orange)]" style="font-size: 15px">{{ 'nav.reservations' | translate }}</a>
          <app-button [ngClass]="{'hidden': !(isAuthenticated$ | async)}" [function]="logout.bind(this)" [text]="'nav.logout' | translate"
            [style]="'secondary'" [fullWidth]="true"></app-button>
          <app-button [ngClass]="{'hidden': (isAuthenticated$ | async)}" [function]="goToLogin.bind(this)" [text]="'nav.login' | translate"
            [style]="'secondary'" [fullWidth]="true"></app-button>
  
          <!-- Cart Icon (Desktop) -->
          <a #cartIcon routerLink="/cart" routerLinkActive="cart-active" [routerLinkActiveOptions]="{exact: true}" class="relative transition-colors duration-200 hover:text-[var(--dark-orange)]" aria-label="Carrito de compras">
            <fa-icon [icon]="faShoppingCart" size="2xl"></fa-icon>
            <span *ngIf="((cartItemCount$ | async) || 0) > 0" class="absolute -top-2 -right-2 bg-red-600 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
              {{ cartItemCount$ | async }}
            </span>
          </a>

            <div class="flex gap-4 items-center">
              <a href="https://www.instagram.com/drink.hopping" target="_blank" rel="noopener noreferrer"
              class="transition-colors duration-200 hover:text-[var(--dark-orange)]" style="font-size: 15px;" aria-label="Instagram">
              <fa-icon [icon]="faInstagram" size="2xl"></fa-icon>
            </a>
            <a href="https://www.tiktok.com/@drink.hopping" target="_blank" rel="noopener noreferrer"
              class="transition-colors duration-200 hover:text-[var(--dark-orange)]" style="font-size: 15px" aria-label="TikTok">
              <fa-icon [icon]="faTiktok" size="2xl"></fa-icon>
            </a>
            <app-language-selector></app-language-selector>
            </div>
  
        </div>
      </div>
    </nav>
  
    <div *ngIf="isHome" class="relative pb-16">
      <div class="flex">
        <div class="relative flex-grow my-44 mobile:my-36 mobile-m:28 tablet:my-24 desktop:my-20">
          <div class="">
            <h1 class="relative z-[1] text-[var(--dark-orange)]" style="font-size: clamp(75px, 20.5vw, 245px); line-height: 0.8; width: min-content;">
              <span class="block explora">{{ 'home.explora' | translate }}</span>
              <span class="block disfruta">{{ 'home.disfruta' | translate }}</span>
              
              <div class="absolute z-[2] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 mobile-m:left-[80%] tablet:left-[90%] desktop:left-[100%]">
                <img
                  src="assets/mascota.webp"
                  alt="Drinkhopping hoppinsito"
                  style="height: clamp(350px, 44vw, 490px); max-height: clamp(350px, 44vw, 490px);"
                  class="max-w-[fit-content] mascota"
                />
              </div>
            
              <div class="absolute z-[0] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 mobile-m:left-[80%] tablet:left-[90%] desktop:left-[100%]">
                <img
                  src="assets/explosion-fondo.webp"
                  alt="drinkhopping hoppinsito"
                  style="opacity: 0.2; max-width: clamp(400px, 55vw, 650px);"
                  class="explosion-fondo"
                />
              </div>
            </h1>
          </div>
      
          <div class="z-[3] absolute bottom-0 right-0 hidden desktop:block" style="writing-mode: sideways-lr">
            <h2 class="uppercase vive-la-experiencia" style="font-size: clamp(30px, 5vw, 73px); font-weight: 400; line-height: 0.8;">
              {{ 'home.viveExperiencia' | translate }}
            </h2>
          </div>
        </div>
      </div>
  
      <div class="flex flex-col justify-between mobile-m:flex-row mobile-m:items-end gap-12">
        <div class="text-left">
          <h3 class="uppercase text-[60px]/[60px]" style="font-weight: 400;">
            Drink <br>Hopping <br>Experience
          </h3>
        </div>
      
        <app-busca-redime-vive class="w-full"></app-busca-redime-vive>
      </div>
  
    </div>
  </div>
  
    


</header>

<div [ngClass]="{'hidden': !isMobileMenuOpen}" class="mobile-menu md:hidden fixed top-0 left-0 w-[100%] h-[100%] z-[100000]" style="background-color: var(--white);">

  <div class="relative w-[100%] h-[100%] flex items-center justify-center" style="background-image: url(assets/fondo-rugoso.webp);">
    <button 
    class="absolute top-[16px] right-[16px] border border-[3px] border-[var(--dark-orange)] rounded-full p-1" 
    (click)="toggleMobileMenu()"
  >
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      class="h-3 w-3" 
      fill="none" 
      viewBox="0 0 24 24" 
      stroke="var(--dark-orange)"
    >
      <path 
        stroke-linecap="round" 
        stroke-linejoin="round" 
        stroke-width="6" 
        d="M6 18L18 6M6 6l12 12" 
      />
    </svg>
    </button>

    <div class="flex flex-col items-center gap-4">

        <div class="flex justify-center mb-5">
          <a routerLink="home" class="flex items-center">
            <img src="assets/logo.webp" alt="Drinkhopping logo" class="h-[89px]">
          </a>
        </div>
  
        <div class="flex gap-4 justify-center">
          <a href="https://www.instagram.com/drink.hopping" target="_blank" rel="noopener noreferrer"
          class="uppercase font-normal" style="font-size: 15px;" aria-label="Instagram">
          <fa-icon [icon]="faInstagram" size="2xl"></fa-icon>
        </a>
        <a href="https://www.tiktok.com/@drink.hopping" target="_blank" rel="noopener noreferrer"
          class="uppercase font-normal" style="font-size: 15px" aria-label="TikTok">
          <fa-icon [icon]="faTiktok" size="2xl"></fa-icon>
        </a>
        </div>
          <a (click)="toggleMobileMenu()" routerLinkActive="routerActive" routerLink="" [routerLinkActiveOptions]="{exact: true}" class="uppercase font-normal text-center transition-colors duration-200 hover:text-[var(--dark-orange)]" style="font-size: 15px">{{ 'nav.home' | translate }}</a>
          <a (click)="toggleMobileMenu()" routerLinkActive="routerActive" routerLink="/events" class="uppercase font-normal text-center transition-colors duration-200 hover:text-[var(--dark-orange)]" style="font-size: 15px">{{ 'nav.events' | translate }}</a>
          <a (click)="toggleMobileMenu()" routerLinkActive="routerActive" routerLink="/register" class="uppercase font-normal text-center transition-colors duration-200 hover:text-[var(--dark-orange)]" style="font-size: 15px" [ngClass]="{'hidden': (isAuthenticated$ | async)}">{{ 'nav.register' | translate }}</a>
          <a (click)="toggleMobileMenu()" routerLinkActive="routerActive" routerLink="/new-hop" class="uppercase font-normal text-center transition-colors duration-200 hover:text-[var(--dark-orange)]" style="font-size: 15px">{{ 'nav.newHop' | translate }}</a>
          
          <a (click)="toggleMobileMenu()" routerLinkActive="routerActive" [ngClass]="{'hidden': !(isAuthenticated$ | async)}" routerLink="/profile" class="uppercase font-normal text-center transition-colors duration-200 hover:text-[var(--dark-orange)]" style="font-size: 15px">{{ 'nav.profile' | translate }}</a>
          <a (click)="toggleMobileMenu()" routerLinkActive="routerActive" [ngClass]="{'hidden': !(isAuthenticated$ | async)}" routerLink="/reservations" class="uppercase font-normal text-center transition-colors duration-200 hover:text-[var(--dark-orange)]" style="font-size: 15px">{{ 'nav.reservations' | translate }}</a>
          <a (click)="toggleMobileMenu()" routerLinkActive="routerActive" routerLink="/cart" class="uppercase font-normal text-center relative inline-block transition-colors duration-200 hover:text-[var(--dark-orange)]" style="font-size: 15px">
            {{ 'nav.cart' | translate }}
            <span *ngIf="((cartItemCount$ | async) || 0) > 0" class="inline-block ml-1 bg-red-600 text-white text-xs font-bold rounded-full h-5 w-5 text-center leading-5">
              {{ cartItemCount$ | async }}
            </span>
          </a>
          <app-button (click)="toggleMobileMenu()" [ngClass]="{'hidden': !(isAuthenticated$ | async)}" [function]="logout.bind(this)" [text]="'nav.logout' | translate" [fullWidth]="true"></app-button>
          <app-button (click)="toggleMobileMenu()" [ngClass]="{'hidden': (isAuthenticated$ | async)}" [function]="goToLogin.bind(this)" [text]="'nav.login' | translate" [fullWidth]="true"></app-button>

          <!-- Language selector mobile -->
          <div class="flex justify-center mt-2">
            <app-language-selector [openUp]="true"></app-language-selector>
          </div>

    </div>

  </div>





</div>